import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ORDERS_FILTERS_V2_API_TOKEN } from '@epicuro-next/data/order-book';
import { IOrdersSettings } from '@epicuro-next/models/order-book';
import { ENVIRONMENT_SETTINGS } from '@epicuro-next/platform/environment';

import { getOrderSettings } from './shared';
import { ORDERS_SETTINGS_TOKEN } from './tokens';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        loadComponent: () =>
          import(
            './containers/order-materials-page/order-materials-page.component'
          ).then((m) => m.OrderMaterialsPageComponent),
      },
      {
        path: ':orderNumber',
        loadComponent: () =>
          import(
            './containers/order-detail-page/order-detail-page.component'
          ).then((m) => m.OrderDetailPageComponent),
      },
    ]),
  ],
  providers: [
    {
      provide: ORDERS_SETTINGS_TOKEN,
      useFactory: getOrderSettings,
      deps: [ENVIRONMENT_SETTINGS],
    },
    {
      provide: ORDERS_FILTERS_V2_API_TOKEN,
      useFactory: (orderSetting: IOrdersSettings) => {
        return orderSetting.enableOrderMaterials === 'true'
          ? 'materials/filters'
          : 'filters';
      },
      deps: [ORDERS_SETTINGS_TOKEN],
    },
  ],
})
export class FeaturesOrderBookV2Module {}
